// eslint-disable-next-line no-restricted-imports -- AppLink is the one place allowed to wrap next/link; every other file imports AppLink.
import Link from "next/link";
import type { ComponentProps } from "react";

export type AppLinkProps = ComponentProps<typeof Link>;

/**
 * The app's `<Link>`: next/link with viewport prefetch OFF by default.
 *
 * Every page here is dynamic and has no loading.js, so an auto prefetch fetches
 * nothing the router can reuse, yet each one is a full RSC render in the
 * Amplify SSR Lambda. A dashboard or /pay list put dozens of links in view and
 * fired one Lambda call per link, contending with the post-/self data burst.
 * Revisits are served from the client router cache instead
 * (`experimental.staleTimes.dynamic` in next.config.mjs).
 *
 * Pass `prefetch` explicitly to opt a single link back in. If pages ever
 * become static, this default is the one line to change.
 */
export function AppLink({ prefetch = false, ...props }: AppLinkProps) {
  return <Link prefetch={prefetch} {...props} />;
}
